import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { PlaygroundVisual } from './PlaygroundVisual';
import { sideProjects } from '../../data/writing';
export function Playground() {
  return <section id="playground" className="mt-28 scroll-mt-24 lg:scroll-mt-10" data-id="element-262" data-mp="9on94qaso5oe">
      <SectionHeading index="03" label="Playground" title="Side projects & experiments" data-id="element-263" data-mp="enrfzaa8xrbk" />
      <div className="mt-8 grid gap-6 md:grid-cols-3" data-id="element-264" data-mp="jljiszcfixuj">
        {sideProjects.map((project, i) => {
        const href = 'href' in project ? project.href : undefined;
        const body = <>
              <div className="relative aspect-[4/3] overflow-hidden rounded-2xl" data-id="element-265" data-mp="slog2gnwsfuz">
                <div className={`absolute inset-0 ${href ? 'transition-transform duration-200 ease-out group-hover:scale-[1.015]' : ''}`} data-id="element-266" data-mp="2pfj66yp6heb4">
                  {'image' in project && project.image ? <img src={project.image.src} alt={project.image.alt} className={`h-full w-full object-cover ${project.image.mono ? 'object-[center_30%] grayscale' : 'object-center'}`} data-id="element-267" data-mp="2nt0ondfrrbj6" /> : <PlaygroundVisual visual={project.visual} data-id="element-268" data-mp="36q1vz4wspnqa" />}
                </div>
              </div>
              <h3 className={`mt-4 text-[15px] font-semibold text-fg ${href ? 'transition-colors duration-150 group-hover:text-ink' : ''}`} data-id="element-269" data-mp="32ognrwv7hxmf">
                {project.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-fg-muted" data-id="element-270" data-mp="2sq0upocmceaa">{project.description}</p>
              {href && <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-ink" data-id="element-271" data-mp="1m8dq1foyvajw">
                  Open the deck
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-272" data-mp="1is153tsom26p" />
                </span>}
            </>;
        return <Reveal key={project.title} delay={i * 0.05} data-id="element-273" data-mp="19snqyntm4pfn" data-mpi={i}>
              {href ? <Link to={href} className="group block rounded-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 focus-visible:ring-offset-4 focus-visible:ring-offset-canvas" data-id="element-274" data-mp="1eqfvqifcw619">
                  {body}
                </Link> : <article data-id="element-275" data-mp="r2efenbxrlba">{body}</article>}
            </Reveal>;
      })}
      </div>
    </section>;
}